import React, { useState } from "react";
import { Modal, Button, message } from "antd";
import { InputSelect } from "../Inputs/Inputs";
import { nexBttn, contentTxt } from "../../styles/StepsStyles";
import { postMethodContactChange } from "../../apis/ApiPOST";
import { useAppSelector } from "../../hooks/storeHooks";

interface ContactMethodModalProps {
  open: boolean;
  onClose: () => void;
}

const contactMethods = [
  { id: 1, name: "Correo" },
  { id: 2, name: "SMS" },
  { id: 3, name: "WhatsApp" },
];

const ContactMethodModal: React.FC<ContactMethodModalProps> = ({
  open,
  onClose,
}) => {
  const [methodContact, setMethodContact] = useState(0);
  const [loading, setLoading] = useState(false);

  const dataResponse = useAppSelector((state) => state.DataResponse);
  const preauthId = dataResponse.UserId;

  const handleUpdate = async () => {
    if (!preauthId) {
      message.error("No se encontró el identificador de preautorización");
      return;
    }

    if (!methodContact) {
      message.warning("Seleccione un método de contacto");
      return;
    }
    const selectedMethod = contactMethods.find(
      (method) => method.id === methodContact
    );

    setLoading(true);

    try {
      await postMethodContactChange(preauthId, methodContact);
      message.success(
        `Método de contacto actualizado. ${selectedMethod?.name} enviado exitosamente`
      );
      onClose();
    }catch (error) {
      message.error("Error al actualizar el método de contacto");
    }finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      className="contact-method-modal"
      footer={null}
      centered
    >
      <div style={{ marginTop: 30 }}>
        <InputSelect
          label="Método de contacto"
          setValue={setMethodContact}
          value={methodContact}
          listItems={contactMethods}
        />
      </div>

      <div style={{ marginTop: 30, textAlign: "center" }}>
        <Button
          shape="round"
          style={{ ...nexBttn }}
          onClick={handleUpdate}
          loading={loading}
          disabled={loading || !methodContact}
        >
          Actualizar
        </Button>
      </div>
    </Modal>
  );
};

export default ContactMethodModal;
